import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

import { PiLockLaminated } from 'react-icons/pi'

import ProgressBar from '@components/common/ProgressBar/ProgressBar'
import ButtonLink from '@components/common/Button/ButtonLink'

import MotionText from '@/components/common/Motion/MotionText'
import MotionDiv from '@/components/common/Motion/MotionDiv'
import MotionImage from '@/components/common/Motion/MotionImage'

import TimeVisual from '@assets/visuals/time.webp'
import { usePageSetup } from '@/hooks/usePageSetup'

import { useKycStore } from '@store/useKycStore'

export const KycIntroPage = () => {
  const { t } = useTranslation()
  usePageSetup(t('kyc.pageTitle.intro'), { scroll: true })

  const progress = useKycStore((state) => state.progress)
  const setProgress = useKycStore((state) => state.setProgress)

  useEffect(() => setProgress(1), [])

  return (
    <div className="h-full bg-white p-5 pt-8 pb-8 flex flex-col">
      <div className="space-y-4">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 500,
            damping: 30,
            mass: 1
          }}
        >
          <ProgressBar
            currentStep={progress}
            totalSteps={8}
          />
        </motion.div>
        <motion.div
          initial={{ y: "-1.5rem" }}
          animate={{ y: 0 }}
          transition={{
            type: "spring",
            stiffness: 500,
            damping: 30,
            mass: 1
          }}
        >
        </motion.div>
      </div>
      <div className="flex-1 flex flex-col">
        <MotionImage
          className="h-[14.5rem] w-[14.5rem] mx-auto object-cover"
          src={TimeVisual}
          alt={"Time visual"}
        />
        <div className="space-y-4">
          <MotionText
            as="h2"
            className="text-[2.5rem] font-hubot font-black uppercase leading-none text-center mx-8"
            delay={0.2}
          >
            {t('kyc.intro.title')}
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base text-center mx-5"
            delay={0.4}
          >
            {t('kyc.intro.description')}
          </MotionText>
        </div>
        <MotionDiv
          delay={0.8}
          className='flex flex-row gap-2 items-center mt-auto mb-5 mx-auto'>
          <PiLockLaminated className="w-6 h-6 text-green-500" />
          <p className='text-zinc-700 text-sm'>
            {t('kyc.intro.dataSecure')}
          </p>
        </MotionDiv>
      </div>

      <div className="space-y-4">
        <ButtonLink to={'/kyc/details'}>
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2,
              ease: "easeOut"
            }}
          >
            {t('common.continue')}
          </motion.span>
        </ButtonLink>
      </div>
    </div>
  )
}

export default KycIntroPage